export const QR_CODE_TYPES = {
  SHARE_TO_USER: 0
};
